import { mode } from '@chakra-ui/theme-tools';

const overlayBg = 'rgba(7, 50, 5, 0.48)';
const dialogShadow = '0 24px 64px rgba(17, 24, 18, 0.18)';

export const overlayStyles = {
  components: {
    Modal: {
      baseStyle: (props) => ({
        overlay: {
          bg: overlayBg,
          backdropFilter: 'blur(8px)',
        },
        dialog: {
          borderRadius: '24px',
          bg: mode('#ffffff', 'navy.800')(props),
          border: '1px solid',
          borderColor: mode('rgba(17, 24, 18, 0.08)', 'whiteAlpha.200')(props),
          boxShadow: dialogShadow,
          overflow: 'hidden',
        },
        header: {
          fontFamily: "'IBM Plex Sans', sans-serif",
          fontWeight: '500',
          fontSize: '20px',
          color: mode('#111812', 'white')(props),
          bg: mode('#F6F7F9', 'whiteAlpha.50')(props),
          px: '28px',
          pt: '24px',
          pb: '12px',
        },
        closeButton: {
          top: '16px',
          right: '16px',
          borderRadius: '10px',
          color: mode('#3D433E', 'whiteAlpha.800')(props),
          _hover: { bg: mode('#F6F7F9', 'whiteAlpha.100')(props) },
        },
        body: {
          px: '28px',
          py: '16px',
          color: mode('#3D433E', 'whiteAlpha.800')(props),
        },
        footer: {
          px: '28px',
          pb: '24px',
          pt: '16px',
          gap: '10px',
          bg: mode('#F6F7F9', 'whiteAlpha.50')(props),
        },
      }),
    },
    AlertDialog: {
      baseStyle: (props) => ({
        overlay: {
          bg: overlayBg,
          backdropFilter: 'blur(8px)',
        },
        dialog: {
          borderRadius: '24px',
          bg: mode('#ffffff', 'navy.800')(props),
          border: '1px solid',
          borderColor: mode('rgba(17, 24, 18, 0.08)', 'whiteAlpha.200')(props),
          boxShadow: dialogShadow,
          overflow: 'hidden',
        },
        header: {
          fontFamily: "'IBM Plex Sans', sans-serif",
          fontWeight: '500',
          fontSize: '20px',
          color: mode('#111812', 'white')(props),
          px: '28px',
          pt: '24px',
        },
        closeButton: {
          top: '16px',
          right: '16px',
          borderRadius: '10px',
        },
        body: {
          px: '28px',
          py: '12px',
          color: mode('#3D433E', 'whiteAlpha.800')(props),
        },
        footer: {
          px: '28px',
          pb: '24px',
          pt: '16px',
          bg: mode('#F6F7F9', 'whiteAlpha.50')(props),
        },
      }),
    },
    Drawer: {
      baseStyle: (props) => ({
        overlay: {
          bg: overlayBg,
          backdropFilter: 'blur(8px)',
        },
        dialog: {
          bg: mode('#ffffff', 'navy.800')(props),
        },
      }),
    },
    Menu: {
      baseStyle: (props) => ({
        list: {
          borderRadius: '16px',
          border: '1px solid',
          borderColor: mode('rgba(17, 24, 18, 0.08)', 'whiteAlpha.200')(props),
          boxShadow: '0 12px 32px rgba(17, 24, 18, 0.12)',
          bg: mode('#ffffff', 'navy.800')(props),
          py: '8px',
          overflow: 'hidden',
        },
        item: {
          borderRadius: '10px',
          mx: '8px',
          px: '12px',
          fontSize: '14px',
          _hover: { bg: mode('#E8F6E3', 'whiteAlpha.100')(props) },
          _focus: { bg: mode('#E8F6E3', 'whiteAlpha.100')(props) },
        },
      }),
    },
    Popover: {
      baseStyle: (props) => ({
        content: {
          borderRadius: '16px',
          border: '1px solid',
          borderColor: mode('rgba(17, 24, 18, 0.08)', 'whiteAlpha.200')(props),
          boxShadow: '0 12px 32px rgba(17, 24, 18, 0.12)',
          bg: mode('#ffffff', 'navy.800')(props),
        },
      }),
    },
  },
};
